'use client';

import {
  MenuContent,
  MenuItem,
  MenuRoot,
  MenuTrigger,
} from '@/components/ui/menu';
import { FEATURED_BRANDS, BRAND_NAMES, BRAND_LOGO } from '@/_utils/Constants';
import { Box, Image, Text } from '@chakra-ui/react';
import { useRouter } from '@/i18n/navigation';
import { ChevronDown } from 'lucide-react';
import { getBrandHref } from '@/_lib/brand-href';

const BRANDS = Object.entries(FEATURED_BRANDS)
  // Hide Yoko Pizza from brand select
  .filter(([, shipperId]) => shipperId !== FEATURED_BRANDS.yokopizza)
  .map(([key, shipperId]) => ({
    shipperId,
    name: BRAND_NAMES[shipperId] || key,
    logo: BRAND_LOGO[shipperId],
  }));

interface BrandSelectMobileProps {
  brandName: string;
}

export default function BrandSelectMobile({ brandName }: BrandSelectMobileProps) {
  const router = useRouter();

  const handleSelectBrand = (shipperId: string) => {
    router.push(getBrandHref(shipperId));
  };

  return (
    <MenuRoot positioning={{ placement: 'bottom-start', offset: { mainAxis: 8 } }}>
      <Box w='fit' display='flex' alignItems='center' gap={1}>
        <Text fontSize='xl' fontWeight={600} lineHeight={1.2}>
          {brandName}
        </Text>
        <MenuTrigger asChild>
          <Box
            as='button'
            cursor='pointer'
            display='flex'
            alignItems='center'
            aria-label={brandName}
            _hover={{ opacity: 0.9 }}
          >
            <ChevronDown size={20} strokeWidth={2} />
          </Box>
        </MenuTrigger>
      </Box>
      <MenuContent
        minW="200px"
        py={2}
        rounded={12}
        bg="background.card"
        border="1px solid"
        borderColor="gray.200"
      >
        {BRANDS.map(({ shipperId, name, logo }) => (
          <MenuItem
            key={shipperId}
            value={shipperId}
            cursor="pointer"
            onClick={() => handleSelectBrand(shipperId)}
            py={2}
            px={2}
            display="flex"
            alignItems="center"
            rounded={6}
            gap={2}
          >
            {logo && (
              <Image
                src={logo}
                alt={name}
                width="32px"
                height="32px"
                objectFit="contain"
                rounded={6}
              />)}
            <Text fontSize="sm" fontWeight={600} color="text">{name}</Text>
          </MenuItem>
        ))}
      </MenuContent>
    </MenuRoot>
  );
}
